export enum FreeMintModalKeys {
  NftOrder = 'NftOrder',
  NotLoggedIn = 'NotLoggedIn',
  SuccessfulMint = 'SuccessfulMint',
  UnsuccessfulMint = 'UnsuccessfulMint',
}
